export const ARCHIVE_ONLY = 'Archive only';
